import { render, staticRenderFns } from "./AnnouncementsPage.vue?vue&type=template&id=91ecaf42&"
import script from "./AnnouncementsPage.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports